import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, SEO } from '../../../components/common';

/**
 * 404 Not Found 페이지 — BugHerd #190.
 * 모든 미매칭 라우트를 catch-all 로 받아 표시. SEO 의 noindex 적용으로 크롤러 인덱싱 차단.
 */
export default function NotFound() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        route="/404"
        titleOverride="404 Not Found · VIP Van Tour"
        descriptionOverride={t('notfound.description', { defaultValue: '요청하신 페이지를 찾을 수 없습니다.' })}
        noindex
      />
      <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12 bg-mono-50">
        <div className="max-w-md w-full text-center">
          <h1 className="text-6xl font-extrabold text-orange-500 mb-3">404</h1>
          <h2 className="text-xl font-bold text-mono-900 mb-2">
            {t('notfound.title', { defaultValue: '페이지를 찾을 수 없습니다' })}
          </h2>
          <p className="text-2sm text-mono-500 mb-6 break-keep">
            {t('notfound.description', { defaultValue: '요청하신 페이지가 이동되었거나 더 이상 존재하지 않습니다.' })}
          </p>
          <Link to="/">
            <Button level="primary">
              {t('notfound.go_home', { defaultValue: '홈으로 돌아가기' })}
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
}
